import {
  BusinessFormType,
  CAFormType,
} from '../../components/ContactSales/utils/types';
import { cleartaxAxios } from '../../http-common';
import {
  companySearchTransformer,
  createLeadTransformer,
} from './transformer/createLeadTransformer';

type CreateLeadPlatformsType = {
  hubspot: Record<string, string>;
  lsq?: { add_activity?: boolean };
  salesforce: boolean;
  pardot?: boolean;
};

type UpdateLeadPlatformsType = {
  lsq?: { add_activity?: boolean };
};

type FormDataType = {
  lead_data: Partial<BusinessFormType | CAFormType>;
  lead_platforms: CreateLeadPlatformsType | UpdateLeadPlatformsType;
};

export const createLead = (
  formData: FormDataType,
  token: string
): Promise<string> => {
  return new Promise((resolve, reject) => {
    cleartaxAxios
      .post(`/f/common-lead/lead/?captcha_token=${token}`, formData)
      .then((response) => {
        try {
          if (response.status == 201 || !response.data) {
            resolve(createLeadTransformer(response.data));
          } else throw 'Api error';
        } catch (err) {
          reject(err);
        }
      })
      .catch((err) => reject(err));
  });
};

export const bookAppointment = (
  token: string,
  id: string,
  formattedBookingDate: string,
  setFormSubmitted: (value: boolean) => void
): Promise<string> => {
  return new Promise((resolve, reject) => {
    cleartaxAxios
      .patch(`/f/common-lead/lead/${id}/?captcha_token=${token}`, {
        lead_data: {
          appointment: formattedBookingDate,
        },
        lead_platforms: {
          lsq: { add_appointment: true },
        },
      })
      .then((response) => {
        setFormSubmitted(true);
        resolve(createLeadTransformer(response.data));
      })
      .catch((err) => reject(err));
  });
};

export const updateLead = (
  formData: FormDataType,
  token: string,
  id: string
): Promise<string> => {
  return new Promise((resolve, reject) => {
    cleartaxAxios
      .patch(`/f/common-lead/lead/${id}/?captcha_token=${token}`, {
        ...formData,
        recaptchaToken: token,
      })
      .then((response) => {
        resolve(createLeadTransformer(response.data));
      })
      .catch((err) => reject(err));
  });
};

export const companySearch = (
  query: string
): Promise<Array<{ value: string; label: string }>> => {
  return new Promise((resolve, reject) => {
    cleartaxAxios
      .get(`/f/name-to-pan?company_name=${query}`)
      .then((response) => {
        resolve(companySearchTransformer(JSON.stringify(response.data)));
      })
      .catch((err) => reject(err));
  });
};
